if (!window.Eurus.loadedScript.has('recently-viewed.js')) {
  window.Eurus.loadedScript.add('recently-viewed.js');

  requestAnimationFrame(() => {
    document.addEventListener('alpine:init', () => {
      Alpine.store('xProductRecently', {
        show: false,
        productsToShow: 0,
        productsToShowMax: 10,
        init() {
          if (document.getElementById('shopify-section-recently-viewed')) {
            this.productsToShow = document.getElementById('shopify-section-recently-viewed').getAttribute("x-products-to-show");
          }
        },
        showProductRecently() {
          if (localStorage.getItem("recently-viewed")?.length) {
            this.show = true;
          } else {
            this.show = false;
          }
        },
        setProduct(productViewed) {
          let productList = [];
          if (localStorage.getItem("recently-viewed")?.length) {
            productList = JSON.parse(localStorage.getItem("recently-viewed")); 
            productList = [...productList.filter(p => p !== productViewed)].filter((p, i) => i<this.productsToShowMax);
            this.show = true;
            let newData = [productViewed, ...productList];
            localStorage.setItem('recently-viewed', JSON.stringify(newData))
          } else {
            this.show = false;
            localStorage.setItem('recently-viewed', JSON.stringify([productViewed]));
          }
        },
        getProductRecently(sectionId, productId) {
          let products = [];
          const el = document.getElementById("shopify-section-recently-viewed");
          if (el && el.getAttribute("x-products-to-show")) {
            this.productsToShow = parseInt(el.getAttribute("x-products-to-show"), 10) || 10;
          }
          if (localStorage.getItem("recently-viewed")?.length) {
            products = JSON.parse(localStorage.getItem("recently-viewed"));
            products = productId ? [...products.filter(p => p !== productId)] : products;
            products = products.slice(0, this.productsToShow || 10);
          } else {
            return;
          }
          let query = products.map(value => "id:" + value).join(' OR ');
          var search_url = `${Shopify.routes.root}search?section_id=${ sectionId }&type=product&q=${query}`;
          fetch(search_url).then((response) => {
            if (!response.ok) {
              var error = new Error(response.status);
              console.log(error)
              throw error;
            }
    
            return response.text();
          })
          .then((text) => {
            const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').getElementById('shopify-section-recently-viewed').innerHTML;
            el.innerHTML = resultsMarkup;
            // Find the splide element in the new DOM and initialize it directly.
            // We cannot use Alpine.initTree(el) because el has x-init that calls
            // getProductRecently() again, creating an infinite fetch loop.
            // We also cannot rely on x-intersect because it may not fire for
            // already-visible elements inserted dynamically.
            const splideEl = el.querySelector('.x-splide.splide');
            if (splideEl && window.Alpine && Alpine.store('xSplide')) {
              // Read the Splide config from the x-intersect attribute
              const intersectAttr = splideEl.getAttribute('x-intersect.once.margin.200px');
              if (intersectAttr) {
                // Extract the JSON config from $store.xSplide.load($el, {...})
                const configMatch = intersectAttr.match(/\$store\.xSplide\.load\(\$el,\s*(\{[\s\S]*\})\s*\)/);
                if (configMatch && configMatch[1]) {
                  try {
                    // Clean the config string: remove JS arrow functions (events callbacks)
                    let configStr = configMatch[1];
                    // Remove the events array entirely (contains JS functions that can't be JSON.parsed)
                    configStr = configStr.replace(/"events"\s*:\s*\[[\s\S]*?\]\s*,?/g, '');
                    // Remove trailing commas before closing braces
                    configStr = configStr.replace(/,\s*}/g, '}');
                    configStr = configStr.replace(/,\s*$/g, '');
                    const config = JSON.parse(configStr);
                    // Re-add the events with the ready callback
                    config.events = [{
                      event: 'ready',
                      callback: () => {
                        document.dispatchEvent(new CustomEvent('eurus:' + sectionId + ':splide-ready'));
                      }
                    }];
                    // Give the splide element an id if it doesn't have one
                    if (!splideEl.id) {
                      splideEl.id = 'x-recently-viewed-' + sectionId;
                    }
                    Alpine.store('xSplide').load(splideEl, config);
                  } catch (e) {
                    console.warn('Recently viewed: failed to parse Splide config', e);
                  }
                }
              }
            }
            if (window.Alpine && typeof window.Alpine.initTree === 'function') {
              Array.from(el.children).forEach(child => {
                window.Alpine.initTree(child);
              });
            }
          })
          .catch((error) => {
            throw error;
          });
        },
        clearStory() {
          var result = confirm('Are you sure you want to clear your recently viewed products?');
          if (result === true) {
            localStorage.removeItem("recently-viewed");
            this.show = false;
          }
        }
      })
    })
  });
}